
export const enum QuizStates {
    Loading ,
    Lobby  ,
    Starting,
    Running,
    Finished,
    ReStarting
}
